import { render } from "./ContentCollect.vue?vue&type=template&id=88e94692&scoped=true"
import script from "./ContentCollect.vue?vue&type=script&lang=js"
export * from "./ContentCollect.vue?vue&type=script&lang=js"

import "./ContentCollect.vue?vue&type=style&index=0&id=88e94692&scoped=true&lang=scss"

import exportComponent from "/Users/fanhaipeng/code/giga-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88e94692"]])

export default __exports__